<template>
    <div>
        <app-kpiform v-if="kpi && !loading"
        v-bind:parentObject="{
            kpi: this.kpi,
            KPIItemFull: this.KPIItemFull,
            KPIItemSelectionList: this.KPIItemSelectionList,
            KPICategoryList: this.KPICategoryList,
            list: this.list,
            roleName: this.roleName,
            staffData: this.staffData
        }"
        />
    </div>
</template>

<script>

import KPIForm from '../../sscomponents/performance/MyStaffKPIForm.vue';

export default {

    components: {
        'app-kpiform': KPIForm,
    },

    data() {
        return {
            kpi: this.$route.params.kpi,
            list: this.$route.params.list,
            roleName: this.$route.params.roleName,
            staffData: this.$route.params.staffData,
            KPIItemFull: [],
            KPIItemSelectionList: [],
            KPICategoryList: [],
            isErr: false,
            errMsg: '',
            loading: true
        }
    },

    methods: {
        async loadKPIItemHandler() {
            const vm = this;
            const categoryIdSet = new Set(); // For checking duplicates

            return this.$store.dispatch('get', { url: '/kpiitem/individual/staff/' + vm.kpi.kpiexercisedid })
            .then((res) => {
                vm.KPIItemFull = res.data.rec;
                console.log("KPIItemFull", vm.KPIItemFull);
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.KPIItemSelectionList.push({
                        text: res.data.rec[i].goal + " - " + res.data.rec[i].kpi,
                        goal: res.data.rec[i].goal,
                        kpi : res.data.rec[i].kpi,
                        pmtargetoptionid: res.data.rec[i].pmtargetoptionid,
                        pmcalmethodid: res.data.rec[i].pmcalmethodid,
                        target: res.data.rec[i].target,
                        threshold: res.data.rec[i].threshold,
                        stretch: res.data.rec[i].stretch,
                        weightage: res.data.rec[i].weightage,
                        value: res.data.rec[i].id,
                    });

                    // Extract unique KPI categories
                    if (!categoryIdSet.has(res.data.rec[i].pmkpicatid)) {
                        categoryIdSet.add(res.data.rec[i].pmkpicatid);
                        vm.KPICategoryList.push({
                            id: res.data.rec[i].pmkpicatid,
                            name: res.data.rec[i].pmkpicatname,
                            code: res.data.rec[i].pmkpicatcode,
                            value: res.data.rec[i].pmkpicatid,
                            text: res.data.rec[i].pmkpicatcode + " - " + res.data.rec[i].pmkpicatname
                        });
                    }
                }

                console.log("KPI Category List", vm.KPICategoryList);
                console.log("KPIItemSelectionList", vm.KPIItemSelectionList);
                this.loading = false;

            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },
    },

    async mounted() {
        await this.loadKPIItemHandler();
        console.log("KPI:", this.kpi);
    }
}

</script>

<style scoped>

</style>